import { Table } from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import mainStyle from '../org-management.module.scss';
import { useLocation } from 'react-router-dom';

// Components
import ButtonAction from 'components/ButtonAction';
import TooltipDialogFixed from 'components/TooltipDialogFixed';
import Icon from 'components/Icon';
import LinkerWithRoute from 'components/LinkerWithRoute';

import { renderTableHeader } from 'components/PaginationContainer';

import { useState, useEffect } from 'react';
// import { useSelector, dispatch } from "react-redux";

import { useTranslation } from 'react-i18next';
import { useSortableTable } from 'hooks/useSortableTable';
import useStickyHeader from 'hooks/useStickyHeader';

import Nuclias from "const/nuclias";
import { actionsLabel } from "../const";

const { organizationType, deviceType, userType } = Nuclias;

const OrgManagementTable = ({
  info,
  dataList,
  pagination,
  searchOrg,
  handleModals
}) => {

  const { search } = useLocation();
  // console.log('OrgManagementTable', dataList)
  const { t } = useTranslation();
  // const { pageContext } = useSelector((store) => store);
  const { tableRef, stickyStyle } = useStickyHeader();
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');
  const [tableData, handleSorting] = useSortableTable(dataList, info.columns);

  const getDeviceIcons = (type, data) => {
    return (
      <div className={mainStyle['device-info-container']}>
        <Icon className={'icon-round online'} />
        <div className={mainStyle['device-count']}>{data[type].online}</div>
        <Icon className={'icon-round offline'} />
        <div className={mainStyle['device-count']}>{data[type].offline}</div>
        <Icon className={'icon-round dormant'} />
        <div className={mainStyle['device-count']}>{data[type].dormant}</div>
      </div>
    );
  };

  const getSiteContent = (siteData) => {
    const col = ['ec53a8c4f0', 'a7d6475ec8', 'c03ca67dda', '49757fe172', '0052efad5d', 'a0ea006dc2'];
    return (
      <Table hover className={mainStyle['site-table-tooltips-container']}>
        <thead>
          <tr>
            <th className='px-2'>#</th>
            {col.map((key, index) => (
              <th key={index} className='px-2'>{t(key)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {siteData.map((item, index) => (
            <tr key={item.siteId}>
              <td>{index + 1}</td>
              <td><Icon className={item.status} /></td>
              <td><div>{item.siteName}</div></td>
              <td>{getDeviceIcons('deviceAll', item)}</td>
              <td>{getDeviceIcons('ap', item)}</td>
              <td>{getDeviceIcons('switch', item)}</td>
              <td>{getDeviceIcons('gateway', item)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  const orgTable = () => {
    const list = tableData?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{(pagination.current - 1) * pagination.pageLimit + index + 1}</td>
          <td>
            <LinkerWithRoute
              label={item.name}
              to={item.orgId + (search || '')}
              onClick={() => { }}
            />
          </td>
          <td>{item.orgTypeLabel}</td>
          <td>
            <TooltipDialogFixed
              placement="right"
              title={ReactDOMServer.renderToString(getSiteContent(item.sites))}
              hideIcon={true}
              tooltipsTitle={item.siteCount}
            />
          </td>
          <td>{item.siteTagCount}</td>
          <td>{getDeviceIcons('deviceAll', item)}</td>
          <td>{getDeviceIcons('ap', item)}</td>
          <td>{getDeviceIcons('switch', item)}</td>
          <td>{getDeviceIcons('gateway', item)}</td>
          <td className='table-action-td'>
            <ButtonAction
              label={t(actionsLabel.edit)}
              title={t(actionsLabel.edit)}
              iconClassName="icon-edit"
              disabled={!item?.actions?.canEdit}
              onClick={() => handleModals({ modal: 'org', status: true, type: 'edit', editObj: item })}
            />
            <ButtonAction
              label={t(actionsLabel.createSite)}
              title={t(actionsLabel.createSite)}
              iconClassName="icon-site"
              className="text-uppercase"
              disabled={!item?.actions?.createSite}
              onClick={() => handleModals({ modal: 'site', status: true, type: 'create', editObj: item })}
            />
            <ButtonAction
              label={t(actionsLabel.createTag)}
              title={t(actionsLabel.createTag)}
              iconClassName="icon-tag"
              className="text-uppercase"
              disabled={!item?.actions?.createTag}
              onClick={() => handleModals({ modal: 'tag', status: true, type: 'create', editObj: item })}
            />
            <ButtonAction
              label={t(actionsLabel.invite)}
              title={t(actionsLabel.invite)}
              iconClassName="icon-user"
              className="text-uppercase"
              disabled={!item?.actions?.canInvite}
              onClick={() => handleModals({ modal: 'invite', status: true, type: null, editObj: item })}
            />
          </td>
        </tr>
      );
    });
    return list;
  };

  const mspTable = () => {
    const list = tableData?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{(pagination.current - 1) * pagination.pageLimit + index + 1}</td>
          <td>
            {item.orgType === organizationType.org ?
              <LinkerWithRoute
                label={item.name}
                to={item.id + (search || '')}
              // onClick={() => { gotoOrg(item.id) }}
              /> : item.name
            }
          </td>
          <td>{item.uid}</td>
          <td>{t(item.orgTypeLabel)}</td>
          {info.userType === userType.si &&
            <>
              <td>
                <TooltipDialogFixed
                  placement="right"
                  title={ReactDOMServer.renderToString(getSiteContent(item.sites))}
                  hideIcon={true}
                  tooltipsTitle={item.siteCount}
                />
              </td>
              <td>{item.siteTagCount}</td>
            </>
          }
          <td className='table-action-td'>
            <ButtonAction
              label={t(actionsLabel.edit)}
              title={t(actionsLabel.edit)}
              iconClassName="icon-edit"
              className="text-uppercase"
              disabled={!item?.actions?.canEdit}
              onClick={() => handleModals({ modal: 'org', status: true, type: 'edit', editObj: item })}
            />
            {info.userType === userType.si &&
              <>
                <ButtonAction
                  label={t(actionsLabel.createSite)}
                  title={t(actionsLabel.createSite)}
                  iconClassName="icon-site"
                  className="text-uppercase"
                  disabled={!item?.actions?.createSite}
                  onClick={() => handleModals({ modal: 'site', status: true, type: 'create', editObj: item })}
                />
                <ButtonAction
                  label={t(actionsLabel.createTag)}
                  title={t(actionsLabel.createTag)}
                  iconClassName="icon-tag"
                  className="text-uppercase"
                  disabled={!item?.actions?.createTag}
                  onClick={() => handleModals({ modal: 'tag', status: true, type: 'create', editObj: item })}
                />
              </>
            }

            <ButtonAction
              label={t(actionsLabel.invite)}
              title={t(actionsLabel.invite)}
              iconClassName="icon-user"
              className="text-uppercase"
              disabled={!item?.actions?.canInvite}
              onClick={() => handleModals({ modal: 'invite', status: true, type: null, editObj: item })}
            />
            <ButtonAction
              label={t(actionsLabel.delete)}
              title={t(actionsLabel.delete)}
              iconClassName="icon-trash"
              className="text-uppercase"
              disabled={!item?.actions?.canDelete}
              onClick={() => handleModals({ modal: 'delete', status: true, type: null, editObj: item })}
            />
          </td>
        </tr>
      );
    });
    return list;
  };

  // useEffect(() => {
  //   // console.log('tableData~~~', dataList, searchOrg, info, pagination);
  // }, [dataList, searchOrg, info, pagination]);

  return (
    <>
      <Table responsive striped hover
        className={`table-container ${info.isOrgUser ? mainStyle['org-table-container'] : ''}`}
        ref={tableRef}
      >
        <thead style={stickyStyle}>
          <tr>
            <th>#</th>
            {renderTableHeader(info.columns, order, setOrder, sortField, setSortField, handleSorting)}
            <th className="table-action-th">{t('06df33001c')}</th>
          </tr>
        </thead>
        <tbody>
          {info.isOrgUser ? orgTable() : mspTable()}
        </tbody>
      </Table>
    </>
  );
};

export default OrgManagementTable;
